module.exports = __webpack_public_path__ + "static/media/doc_enrobe_a_chaud.6f745663.pdf";